import {
  COMMISSION_POLICY_STATUS_UPDATE_BEGIN,
  COMMISSION_POLICY_STATUS_UPDATE_SUCCESS,
  COMMISSION_POLICY_STATUS_UPDATE_FAILURE
} from '../constants'

export function reducer(state, action) {
  switch (action.type) {
    case COMMISSION_POLICY_STATUS_UPDATE_BEGIN:
      return {
        ...state,
        policies: {        
        ...state.policies,
        updatePolicyStatusPending: true,
        updatePolicyStatusSuccess: false,
        }
      }
    case COMMISSION_POLICY_STATUS_UPDATE_SUCCESS:
      return {
        ...state,
        policies: {        
          ...state.policies,
        updatePolicyStatusPending: false,
        updatePolicyStatusSuccess: true,
        updatePolicyStatusError: null
        }
      }
    case COMMISSION_POLICY_STATUS_UPDATE_FAILURE:
      return {
        ...state,
        policies: {        
          ...state.policies,
        updatePolicyStatusPending: false,
        updatePolicyStatusError: action.data
        }
      }
    default:
      return state
  }
}
